import type { ThemeConfig } from 'antd';

/** "Basil" design system — a grocery-adjacent but professional B2B palette, deliberately not the
 *  default antd blue. Kept in sync with the CSS custom properties in `app/styles/global.css`
 *  (those exist for the inline `style` props this codebase uses outside antd's own components). */
export const themeTokens = {
  colorPrimary: '#1E7A4C',
  colorLink: '#1E7A4C',
  colorLinkHover: '#3C9C68',
  colorSuccess: '#2F8F5B',
  colorWarning: '#B8790F',
  colorError: '#C1392B',
  colorInfo: '#1E7A4C',

  colorTextBase: '#1A2420',
  colorBgBase: '#FFFFFF',
  colorBgLayout: '#F6F6F2',
  colorBgContainer: '#FFFFFF',
  colorBorder: '#E2E4DC',
  colorBorderSecondary: '#EDEEE8',

  borderRadius: 8,
  borderRadiusLG: 12,
  borderRadiusSM: 6,

  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  fontSizeHeading1: 32,
  fontSizeHeading2: 24,
  fontSizeHeading3: 20,
  fontSizeHeading4: 16,
  fontSizeHeading5: 14,
  lineHeightHeading1: 1.25,
  lineHeightHeading2: 1.3,

  controlHeight: 36,
} satisfies ThemeConfig['token'];
